import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { EmailPreviewDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import Button from '../../../common/components/Button';

import { EmailPreviewModal } from './EmailPreviewModal';

export const EmailPreviewLink = (props: { emailId: string }) => {
  const spd = useSpdCore();
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previewData, setPreviewData] = useState<EmailPreviewDto | null>(null);

  const handleClick = async () => {
    setLoading(true);
    try {
      const preview = await spd.emails.preview(props.emailId);
      setPreviewData(preview);
      setShowPreview(true);
    } catch (error) {
      console.log(
        `Wystąpił problem z wczytaniem podglądu wiadomości e-mail. ${error}`,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="link"
        className="ms-1"
        onClick={handleClick}
        disabled={loading}
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: 'fixed' }}>Podgląd wiadomości</Tooltip>
          }
        >
          <Icon.Eye />
        </OverlayTrigger>
      </Button>
      {previewData && (
        <EmailPreviewModal
          show={showPreview}
          onHide={() => {
            setShowPreview(false);
            setPreviewData(null);
          }}
          preview={previewData}
        />
      )}
    </>
  );
};
